import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {DEFAULT_FILTER_CONFIG} from '../../../../../utils/experiencesFilterConfig'

export type ExperiencesSettingsParams = {
  experiencesFilterConfig: SettingsParamType.String
}

export const experiencesSettingsParams = createSettingsParams<ExperiencesSettingsParams>({
  experiencesFilterConfig: {
    type: SettingsParamType.String,
    getDefaultValue: () => JSON.stringify(DEFAULT_FILTER_CONFIG),
  },
})
